import useProduct from 'data/hooks/useProduct';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { today } from 'components/Form/WeekRangePicker/utils';
import { useEffect, useState, useMemo } from 'react';
import { HoverRange } from 'data/types/hoverRange';
import { Props } from './types';

const useConnect = ({ brandId }: Props) => {
  const { product, isLoading, refetch } = useProduct(brandId);
  const [orderBy, setOrderBy] = useState('desc');
  const allItems = product?.allItems;

  const handleUpdateOrder = (newOrderBy: string) => {
    setOrderBy(newOrderBy);
  };

  const itemsOrdered = useMemo(() => {
    if (orderBy === 'asc') {
      return allItems?.sort((a, b) => (a.sales > b.sales ? 1 : -1));
    }
    return allItems?.sort((a, b) => (a.sales > b.sales ? -1 : 1));
  }, [allItems, orderBy]);

  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId]);

  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(getWeekDays(today));
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };

  return {
    product,
    isLoading,
    handleUpdateOrder,
    itemsOrdered,
    orderBy,
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
  };
};

export default useConnect;
